




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtAdd from "@/components/pages/Attribute/add.vue";
import gtSearch from "@/components/pages/Attribute/search.vue";
import { conditionFilter } from "@root/lib/common";
import { log } from "util";
import { pagination } from "@root/lib/decorator.ts";

const attr = namespace("attribute");
@Component({
  components: { gtAdd, gtSearch }
})
@pagination("getAttrList")
export default class ChooseAttr extends Vue {
  visible: boolean = false;
  input1: string = "";
  multipleSelection: any = [];
  datalist = [];
  total = 0;
  getRowKeys(row) {
    return row.attrCode;
  }
  loading: boolean = false;
  @attr.Action getAttributeList;
  attrValueTypeOptions: any = {
    0: "Single Select",
    1: "Multiple Select",
    3: "Number",
    2: "Text",
    4: "Text Area"
  };

  @Prop({ default: () => [] })
  disabledData: any;
  @Prop({ default: "" })
  title: any;

  @Prop({ default: () => [] })
  conditionList: any;

  @Watch("visible")
  watchVisible(val) {
    if (val) {
      this.input1 = "";
      (this as any).handlePageChange(1);
    }
  }

  mounted() {
    this.getAttrList();
  }
  async getAttrList() {
    this.loading = true;
    let { currentPage, pageSize } = this as any;
    let { list, total } = await this.getAttributeList({
      pageInput: {
        pageNum: currentPage,
        pageSize
      },
      condition: {
        locale: localStorage.getItem("localeLanguage"),
        channel: localStorage.getItem("channel"),
        orgCode: "default",
        attrType: 2,
        conditionList: [
          conditionFilter("attrName", this.input1, 4, this.conditionList)
        ]
      }
    });
    this.datalist = list;
    this.total = total;

    this.loading = false;
  }
  filterIsDisabled(row, index) {
    return this.disabledData.every(item => {
      return item.attrCode !== row.attrCode;
    });
  }
  handleSearch() {
    (this as any).handlePageChange(1);
  }
  handleSelectionChange(val) {
    this.multipleSelection = val;
  }
  handleConfirm() {
    this.$emit("select", this.multipleSelection);
    this.visible = false;
    const $table: any = this.$refs.table;
    $table.clearSelection();
    this.multipleSelection = [];
  }
}
